import { FC } from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react-lite';
import styles from './requestHeader.module.scss';

const RequestHeader: FC = ({ children }) => {
  const { entity } = useParams();
  return (
    <header className={styles.header}>
      <h2 className={styles.headerTitle}>{entity?.toUpperCase()} REQUEST</h2>
      {children}
    </header>
  );
};

export default observer(RequestHeader);
